import { FC, forwardRef } from 'react';
import { HighlightIcon } from '@mews/b2b-ui';
import { IconName } from '@optimus-web/core';
import { TooltippedHighlightIcon } from '@mews-commander/ui';

export const AutomationIcon: FC = () => <HighlightIcon icon={IconName.LightningBolt} variant="primary" size="small" />;

export const TooltippedAutomationIcon = forwardRef<HTMLSpanElement, { tooltip: React.ReactNode }>(
    ({ tooltip }, ref) => (
        <TooltippedHighlightIcon
            size="small"
            value={IconName.LightningBolt}
            iconVariant="primary"
            tooltip={tooltip}
            ref={ref}
        />
    )
);
